// extracted by mini-css-extract-plugin
export default {"container":"NavBar_container__1aQmg"};